import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import ContactsManager from "../components/admin/ContactsManager";
import ServicesManager from "../components/admin/ServicesManager";
import GalleryManager from "../components/admin/GalleryManager";
import { LogOut, MessageSquare, Layers, Image as ImageIcon } from "lucide-react";

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const { t, lang, setLang } = useLang();
  const [tab, setTab] = useState("contacts");

  const tabs = [
    { id: "contacts", label: t("admin.dashboard.tabs.contacts"), icon: MessageSquare },
    { id: "services", label: t("admin.dashboard.tabs.services"), icon: Layers },
    { id: "gallery", label: t("admin.dashboard.tabs.gallery"), icon: ImageIcon },
  ];

  return (
    <div className="min-h-screen bg-[#050506]" data-testid="admin-dashboard">
      <header className="bg-[#121217] border-b border-white/10 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a href="/" className="flex items-center gap-3">
              <img src={`/logo.png?v=5`} alt="İstanbul Organizasyon" className="h-9 w-auto" />
              <span className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] hidden sm:inline">
                Admin
              </span>
            </a>
            <div className="hidden md:block h-6 w-px bg-white/10" />
            <div className="hidden md:block text-xs text-white/40 tracking-widest uppercase">
              {t("admin.dashboard.title")}
            </div>
          </div>

          <div className="flex items-center gap-5">
            <div className="hidden sm:flex items-center gap-2 text-xs">
              <button
                onClick={() => setLang("tr")}
                className={lang === "tr" ? "text-[#D4AF37]" : "text-white/40"}
              >
                TR
              </button>
              <span className="text-white/20">|</span>
              <button
                onClick={() => setLang("fr")}
                className={lang === "fr" ? "text-[#D4AF37]" : "text-white/40"}
              >
                FR
              </button>
            </div>
            <div className="hidden md:block text-xs text-white/50">{user?.email}</div>
            <button
              onClick={logout}
              data-testid="admin-logout"
              className="border border-white/20 text-white hover:border-[#D4AF37]/60 hover:text-[#D4AF37] px-4 py-2 text-xs uppercase tracking-[0.2em] flex items-center gap-2 transition-colors"
            >
              <LogOut size={12} /> {t("admin.dashboard.logout")}
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <div className="mb-10">
          <h1 className="font-display text-4xl md:text-5xl text-white tracking-tighter">
            {t("admin.dashboard.welcome")}
          </h1>
          <div className="h-px w-24 bg-[#D4AF37] mt-4" />
        </div>

        <div className="flex gap-2 mb-8 border-b border-white/10">
          {tabs.map((tb) => {
            const Icon = tb.icon;
            return (
              <button
                key={tb.id}
                onClick={() => setTab(tb.id)}
                data-testid={`admin-tab-${tb.id}`}
                className={`px-5 py-4 text-xs uppercase tracking-[0.25em] border-b-2 transition-colors flex items-center gap-2 -mb-px ${
                  tab === tb.id
                    ? "border-[#D4AF37] text-[#D4AF37]"
                    : "border-transparent text-white/50 hover:text-white"
                }`}
              >
                <Icon size={13} /> {tb.label}
              </button>
            );
          })}
        </div>

        <div>
          {tab === "contacts" && <ContactsManager />}
          {tab === "services" && <ServicesManager />}
          {tab === "gallery" && <GalleryManager />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
